import React from 'react';
import userRoles from '@adjust/dashboard-core/lib/constants/userRoles';
import { connectWithStore } from '@react/Common/connectWithStore';
import { getUserPermissionsState, changeUserRole } from '@redux/ducks/userPermissions/userPermissions';

const ChangeUserRoleComponent = ({ user, changeUserRole }) => (
  <div className="flex-auto form-row form-row-slim">
    <div className="form-row form-row-tight">
      <label>{t('label.role')}</label>
      <div className="role-tags">
        {userRoles.map(role => (
          <label
            key={role.key}
            data-testid={`user.role-${role.key}`}
            className={`role-btn role-${role.key} ${user?.role === role.key && 'active'}`}
          >
            <input type="radio" name="role" value={role.key} onClick={() => changeUserRole(role.key)} />
            {t(role.name)}
          </label>
        ))}
      </div>
    </div>

    <div className="role-desc">
      {userRoles.map(role => (user?.role === role.key ? <p key={role.key}>{t(role.description)}</p> : null))}
    </div>
  </div>
);

const mapStateToProps = state => {
  const { user } = getUserPermissionsState(state);
  return { user };
};

const mapStateToDispatch = {
  changeUserRole,
};

export const ChangeUserRole = connectWithStore(mapStateToProps, mapStateToDispatch)(ChangeUserRoleComponent);
